import React,{useState} from 'react'
import ExpenseForm from './ExpenseForm';

const ExpensesAdd = () => {

    const [mode,setMode] = useState('Adding');

    return (
        <div>
            <ExpenseForm mode={mode} setMode={setMode} />
        </div>
    )
}

export default ExpensesAdd